import { User } from '../types';

interface ConfirmModalProps {
  type: 'enable' | 'disable' | 'toggle';
  user?: User;
  count?: number;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmModal({ type, user, count, onConfirm, onCancel }: ConfirmModalProps) {
  const getTitle = () => {
    if (type === 'toggle') {
      return user?.status === 'normal' ? '禁用账号' : '启用账号';
    }
    return type === 'enable' ? '批量启用' : '批量禁用';
  };

  const getMessage = () => {
    if (type === 'toggle') {
      return user?.status === 'normal'
        ? `确定要禁用用户「${user.username}」吗？禁用后该用户将无法登录系统。`
        : `确定要启用用户「${user.username}」吗？`;
    }
    return type === 'enable'
      ? `确定要启用选中的 ${count} 个用户吗？`
      : `确定要禁用选中的 ${count} 个用户吗？禁用后这些用户将无法登录系统。`;
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4">
        <div className="p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
              type === 'disable' || (type === 'toggle' && user?.status === 'normal')
                ? 'bg-red-100'
                : 'bg-teal-100'
            }`}>
              <i className={`ri-alert-line text-xl ${
                type === 'disable' || (type === 'toggle' && user?.status === 'normal')
                  ? 'text-red-600'
                  : 'text-teal-600'
              }`}></i>
            </div>
            <h3 className="text-lg font-semibold text-gray-900">{getTitle()}</h3>
          </div>
          <p className="text-sm text-gray-600 mb-6">{getMessage()}</p>
          <div className="flex items-center gap-3 justify-end">
            <button
              onClick={onCancel}
              className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors whitespace-nowrap"
            >
              取消
            </button>
            <button
              onClick={onConfirm}
              className={`px-4 py-2 rounded-lg text-sm font-medium text-white transition-colors whitespace-nowrap ${
                type === 'disable' || (type === 'toggle' && user?.status === 'normal')
                  ? 'bg-red-600 hover:bg-red-700'
                  : 'bg-teal-600 hover:bg-teal-700'
              }`}
            >
              确定
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
